import {
  get as localDbGet,
  set as localDbSet
} from 'idb-keyval'
import { CloudWatchLogger } from 'helpers/cloudWatchLogger'
import { INSPECTIONS_ENV_URL } from 'config'

const NETWORK_CHECK_AFTER_X_MESSAGES = 20 // Check network still active after 20 messages sent

async function getHostedEnvironment() {
  const { env } = JSON.parse(await localDbGet("get-tenant-data"))

  return env
}

async function getDbEvents() {
  const dbEvents = await localDbGet('user-events-log')
  const eventsLog = dbEvents ? JSON.parse(dbEvents) : []

  return eventsLog
}

async function logUserEvent(message, isOnline) {
  const { user = 'email', eventType = 'N/A', imageOutboxSize = 'N/A' } = message

  const loggedEvent = {
    user,
    eventType,
    eventTime: new Date().toISOString(),
    onlineStatus: isOnline ? 'Online' : 'Offline',
    imageOutboxSize
  }

  if (isOnline) {
    // send message straight away
    sendEventLog(user, loggedEvent)
  } else {
    // save message for later
    addToPendingLog(loggedEvent)
  }
}

async function addToPendingLog(event) {
  const events = await getDbEvents()

  events.push(event)

  localDbSet('user-events-log', JSON.stringify(events))
}

async function sendSavedEventLogs() {
  const env = await getHostedEnvironment()
  const eventQueue = await getDbEvents()

  let isOnline = true
  let index = 0

  while (eventQueue.length > 0 && isOnline) {
    if (index % NETWORK_CHECK_AFTER_X_MESSAGES) {
      // Quick network check to ensure app is still online
      const targetUrl = env ? INSPECTIONS_ENV_URL[env] : window.location.origin
          
      try {
        const response = await fetch(
          targetUrl,
          {
            method: 'HEAD',
            mode: 'no-cors'
          }
        )
  
        if (response) {
          // device is connected to the internet so able to send an event log
          isOnline = true
        }      
      } catch (err) {
        // device is not connected to the internet so do not send the logs
        isOnline = false
      }
    }

    if (isOnline) {
      const event = eventQueue.shift()

      const { user } = event

      sendEventLog(user, event)

      index += 1
    }
  }

  localDbSet('user-events-log', JSON.stringify(eventQueue))
}


async function sendEventLog(user, reportData) {
  const env = await getHostedEnvironment()

  CloudWatchLogger(
    `/aws/lambda/rest-${env}`,
    "info",
    `${user} User Event Log`,
    reportData
  )
}

export {
  logUserEvent,
  sendSavedEventLogs
}
